import { useState } from 'react';
import { Link } from 'react-router-dom';
import VolunteerActivismIcon from '@mui/icons-material/VolunteerActivism';
import NotesIcon from '@mui/icons-material/Notes';
import { Home } from '@mui/icons-material';
import InfoIcon from '@mui/icons-material/Info';
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary';
import EmailIcon from '@mui/icons-material/Email';
import MenuIcon from '@mui/icons-material/Menu';
import IconButton from '@mui/material/IconButton';
import logo from 'assets/img/logo.png';

export default function DefaultNavbar() {
    const [openNavbar, setOpenNavbar] = useState(false);

    const linkClass = "flex items-center text-white hover:text-gray-300 transition-colors";

    return (
        <nav className="text-white py-4 px-6 shadow-lg" style={{ backgroundColor: '#304c79' }}>
            <div className="container mx-auto">
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                        <img src={logo} alt="Rise Up Logo" className="h-10 w-10 rounded" />
                        <div className="text-xl">Rise Up Prison Ministry</div>
                    </div>

                    {/* Hamburger - mobile only */}
                    <div className="lg:hidden">
                        <IconButton
                            onClick={() => setOpenNavbar(!openNavbar)}
                            sx={{ color: 'white' }}
                        >
                            <MenuIcon />
                        </IconButton>
                    </div>

                    {/* Desktop links */}
                    <div className="hidden lg:block">
                        <div className="flex items-center gap-8 text-xl">
                            <Link to="/" className={linkClass}>
                                <Home />&nbsp;Home
                            </Link>
                            <Link to="/aboutUs" className={linkClass}>
                                <InfoIcon />&nbsp;About Us
                            </Link>
                            <Link to="/testimonials" className={linkClass}>
                                <NotesIcon />&nbsp;Testimonials
                            </Link>
                            <Link to="/gallery" className={linkClass}>
                                <PhotoLibraryIcon />&nbsp;Gallery
                            </Link>
                            <Link to="/contact" className={linkClass}>
                                <EmailIcon />&nbsp;Contact Us
                            </Link>
                            <a
                                href="https://www.paypal.com/donate/?hosted_button_id=GQYSX34TALUHW"
                                target="_blank"
                                rel="noreferrer"
                                className={linkClass}
                            >
                                <VolunteerActivismIcon />&nbsp;Donate
                            </a>
                        </div>
                    </div>
                </div>

                {/* Mobile dropdown */}
                {openNavbar && (
                    <div className="lg:hidden flex flex-col gap-4 mt-4 text-xl">
                        <Link to="/" className={linkClass}>
                            <Home />&nbsp;Home
                        </Link>
                        <Link to="/aboutUs" className={linkClass}>
                            <InfoIcon />&nbsp;About Us
                        </Link>
                        <Link to="/testimonials" className={linkClass}>
                            <NotesIcon />&nbsp;Testimonials
                        </Link>
                        <Link to="/gallery" className={linkClass}>
                            <PhotoLibraryIcon />&nbsp;Gallery
                        </Link>
                        <Link to="/contact" className={linkClass}>
                            <EmailIcon />&nbsp;Contact Us
                        </Link>
                        <a
                            href="https://www.paypal.com/donate/?hosted_button_id=GQYSX34TALUHW"
                            target="_blank"
                            rel="noreferrer"
                            className={linkClass}
                        >
                            <VolunteerActivismIcon />&nbsp;Donate
                        </a>
                    </div>
                )}
            </div>
        </nav>
    );
}
